import {
  PRODUCTS_SET_LIST_TYPE,
  PRODUCTS_RECEIVE_PRODUCTS_WRAPPER,
  FACETED_SEARCH_QUERY,
  PRODUCTS_SET_IS_LOADING,
  PRODUCTS_SET_HAS_REAR_PRODUCTS,
} from '../constants';

const defaultState = {
  name: null,
  url: null,
  productsWrapper: {
    products: [],
    pagination: {},
  },
  listType: 'gallery',
  filterQuery: null,
  isWheelBuilder: false,
  isLoading: false,
  hasRearProducts: false,
};

export const productsView = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case FACETED_SEARCH_QUERY: {
      state.filterQuery = payload.query;
      return state;
    }

    case PRODUCTS_SET_LIST_TYPE:
    case PRODUCTS_RECEIVE_PRODUCTS_WRAPPER:
    case PRODUCTS_SET_IS_LOADING:
    case PRODUCTS_SET_HAS_REAR_PRODUCTS:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};
